module.exports = __webpack_public_path__ + "img/icon-ghs-item.915cc497.svg";